<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" :model="searchForm" ref="searchForm" label-width="70px">
          <el-form-item label="手机号码">
            <el-input v-model.trim="searchForm.phoneNo" placeholder="请输入手机号码" clearable></el-input>
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button type="primary" size="small" @click="selectList">搜索</el-button>
          <el-button class="orange-btn" size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" class="green-btn" size="mini" @click="importExcel">导入</el-button>
      </template>
      <el-table
        ref="tableRef"
        border
        stripe
        :data="tableData.records"
        :height="maxTableHeight"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column prop="phone" label="手机号" min-width="150"></el-table-column>
        <el-table-column prop="updatedBy" label="操作人" min-width="120"></el-table-column>
        <el-table-column prop="updatedDate" label="更新时间" min-width="160"></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div class="footerBox">
          <el-pagination
            @size-change="operationSizeChange"
            @current-change="operationCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            :total="tableData.total"
            layout="total, sizes, prev, pager, next, jumper"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from '@/utils/tableMixin'
export default {
  mixins: [tableMixin, pagePathMixin],
  data() {
    return {
      loading: false,
      stores: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0
      },
      searchForm: {
        phoneNo: '',
      },
    };
  },
  methods: {
    resetSearchForm() {
      this.searchForm= {},
      this.onSearch();
    },
    selectList() {
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    onSearch() {
      this.loading = true;
      const param = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm
        }
      };
      this.$q.dataImport
        .customizedCustomers({ data: JSON.stringify(param) })
        .then(res => {
          if (res.code == 200) {
            res.data.records.forEach((v,index)=>{
              v.id = v.orderNo+ index+( '' +this.tableData.pageNum)
              console.log(v);
            })
            this.tableData = res.data;
          }
        })
        .finally(res => {
          this.loading = false;
        });
    },
    operationSizeChange(pageSize) {
      this.tableData.pageSize = pageSize;
      // 切换每页条数后从第一页搜索
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    operationCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.onSearch();
    },
    importExcel() {
      this.openSubPage({
        //核心语句
        path: "/customImport",
        // name: 'importexcelbyspu',   //跳转的路径
        query: {
          //路由传参时push和query搭配使用 ，作用时传递参数
          // fileType: '18',
          fileName: "电商定制客户导入.xlsx",
          appCode: "ec-pc-new"
        }
      });
    },
  },
  mounted() {
    // console.log();
    // this.getStores();
    this.onSearch();
  }
};
</script>

<style lang="stylus" scoped>
.footerBox
  text-align right

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
    width 240px !important
>>> .date-range .single-date
  width 110px !important

.el-input-group__append button.el-button, .el-input-group__append div.el-select .el-input__inner, .el-input-group__append div.el-select:hover .el-input__inner, .el-input-group__prepend button.el-button, .el-input-group__prepend div.el-select .el-input__inner, .el-input-group__prepend div.el-select:hover .el-input__inner {
  border-color: #0BB78E;
  background-color: #0BB78E;
  color: #FFF;
  border-top: 0;
  border-bottom: 0;
}

.ant-divider, .ant-divider-vertical {
  position: relative;
  top: -.06em;
  display: inline-block;
  width: 1px;
  height: .8em;
  margin: 0 6px;
  vertical-align: middle;
  background-color: #0BB78E;
}

.content
  margin 10px
  >>> .el-header
    padding 10px
    overflow hidden
    background #fff
  >>> .el-main
    background #fff
    margin-top 10px
    padding 10px
  >>> .el-form-item
    margin-bottom 10px

.search-container
  overflow hidden
  margin-bottom 10px
  padding 0 20px

  >>> .el-form-item
    margin-bottom 0

.avatar-uploader
  >>> .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden

    &:hover
      border-color: #409EFF;

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.upload-tip
  margin-left 30px
  margin-top -10px

.preview-content
  text-align center

  p
    margin-bottom 10px

  >>> .el-image
    width 200px
    height 200px

>>> .el-dialog__body
  padding 10px 15px

>>> .el-table__expanded-cell
  padding 10px
  background rgb(250, 250, 250)

.dialog-footer
  text-align center

>>> .input .el-input__inner
      width 150px
      height 28px
</style>
